import { connect } from 'react-redux';
import Footer from './Footer';

const mapStateToProps = ({ content: { footer }, system: { isMobile }}) => ({
  data: footer,
  isMobile
});

export default connect(mapStateToProps, null)(Footer);



// WEBPACK FOOTER //
// ./src/universal/components/Footer/index.js